import dateUtils from '../../../_helpers/dateUtils'

const SecondsString = (path) => (rowData) =>
  rowData[path] ? dateUtils.formatSeconds(rowData[path]) : ''
export default SecondsString
